import { useState } from 'react';
import { Percent } from 'lucide-react';

export const QuoteBulkDiscountBar = ({ total, selectedCount, allSelected, onToggleAll, onApply }) => {
  const [pct, setPct] = useState('');
  const valid = pct !== '' && Number(pct) >= 0 && Number(pct) <= 90;
  const apply = (scope) => { onApply(Number(pct), scope); };
  return (
    <div className="flex flex-wrap items-center gap-2 px-3 py-2.5 border-b border-neutral-200 bg-[color:var(--ije-pink-tint)]/40" data-testid="quote-bulk-discount-bar">
      <label className="inline-flex items-center gap-2 sans text-[10px] tracking-widest uppercase text-neutral-600 cursor-pointer mr-1">
        <input type="checkbox" checked={allSelected} onChange={onToggleAll} className="accent-black w-4 h-4" data-testid="quote-select-all-lines" />
        {selectedCount > 0 ? `${selectedCount} of ${total} selected` : 'Select all'}
      </label>
      <div className="relative">
        <input
          type="number" min={0} max={90} step={0.5}
          value={pct}
          onChange={(e) => setPct(e.target.value)}
          placeholder="Disc"
          className="ije-input h-9 w-24 pr-7 text-sm"
          data-testid="quote-bulk-discount-input"
        />
        <Percent size={12} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-neutral-400 pointer-events-none" />
      </div>
      <button type="button" disabled={!valid} onClick={() => apply('all')} className="btn-primary h-9 disabled:opacity-40" data-testid="quote-bulk-discount-apply-all">
        Apply to all
      </button>
      <button type="button" disabled={!valid || selectedCount === 0} onClick={() => apply('selected')} className="btn-outline h-9 disabled:opacity-40" data-testid="quote-bulk-discount-apply-selected">
        Apply to selected{selectedCount ? ` (${selectedCount})` : ''}
      </button>
    </div>
  );
};
